import { useTranslation } from 'react-i18next'
import { SourcingEventRow } from './useRfxColumns'

export const useRfxStatusLabel = () => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section' })

  return (row: SourcingEventRow) => {
    if (row.kind === 'AUCTION') return t('table.auction')

    const statusLabel = t(`table.statuses.${row.status}`)

    return row.round > 1 ? t('table.statusWithRound', { round: row.round, status: statusLabel }) : statusLabel
  }
}
